/*
 * Tooltip flotante de las gráficas, réplica del tooltip oscuro de Chart.js
 */

/**
 * Renderiza el tooltip si hay información activa
 * @param {Object} props Propiedades del componente
 * @param {Object} props.tip Estado del tooltip { x, y, title, lines } o null
 */
const Tooltipx = ({ tip }) => {
  if (!tip) return null;

  return (
    <div
      style={{
        position: "absolute",
        left: tip.x + 12,
        top: tip.y + 12,
        background: "rgba(15,22,50,.85)",
        color: "#fff",
        borderRadius: 6,
        padding: "8px 10px",
        fontSize: 11.5,
        pointerEvents: "none",
        zIndex: 50,
        whiteSpace: "nowrap",
        boxShadow: "0 4px 12px rgba(0,0,0,.25)",
      }}
    >
      {tip.title ? <div style={{ fontWeight: 700, marginBottom: 2 }}>{tip.title}</div> : null}
      {(tip.lines || []).map((sLine, nIndex) => (
        <div key={nIndex}>{sLine}</div>
      ))}
    </div>
  );
};

export default Tooltipx;
